import PropTypes from 'prop-types'
import React, { useContext, useState, useEffect, useMemo } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { LoadingContext, M_StateActions, MTable } from 'src/M_Components'
import { NavigateContext } from 'src/M_Components';

export default function AccountConfig({ roles, onCreateTab, toastMessages, refresh, setRefresh }) {
    const ctx = useContext(LoadingContext)
    const dispatch = useDispatch()
    const removeContextItems = ['Print', 'Copy']

    const { t, i18n } = useTranslation();
    const { renameTab } = useContext(NavigateContext);
    const selectedTab = useSelector(state => state.StateKeyValue.find(o => o.key === 'selectedTab')?.value);

    //============================================================================================================
    // EFFECT
    // Update tab label when selectedTab or language changes
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return;
        renameTab(selectedTab, t('AccountConfig')); 
    }, [ t, selectedTab]);

    //============================================================================================================
    // Function to create a new route for account operations
    // It dispatches an action to set the operation type and opens a new tab with the specified route
    // If the operation is 'Edit', 'Copy', or 'View', it also sets the selected account data
    //============================================================================================================
    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation }))

        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            if (!data) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            dispatch(M_StateActions.addM_State({ key: 'AccountLine', value: data }))
        }

        const route = '/home/accounts/accountConfigCrud';

        const tabLabel = operation === 'Create'
            ? label
            : `${label} "${data?.Name}"`

        onCreateTab(route, tabLabel)
    }

    //============================================================================================================
    // Memoized map of operation types to their corresponding functions
    //============================================================================================================
    const replaceFunctions = useMemo(() => new Map([
        ['View', (e) => NewRoute('/accountConfigCrud', t("LabelViewAccount"), 'View', e)],
        ['Create', () => NewRoute('/accountConfigCrud', t("LabelNewAccount"), 'Create')],
        ['Edit', (e) => NewRoute('/accountConfigCrud', t("LabelEditAccount"), 'Edit', e)],
    ]), [t]);

    return (
        <div className='divGlobalSettings'>
            <div className='subTitleSettings'>
                <div>
                    <div className="titleSettings" style={{ color: ctx.secondaryColor }}>{t('Accounts')}</div>
                    <div className='labelSubtitleSettings'>{t("InfoAccounts")}</div>
                </div>
            </div>
            <MTable // Dynamic table for account management
                filtersOnTable
                entityName={'Accounts'}
                roleName={'Accounts'}
                rolePermissions={roles?.map(vl => vl.Value)}
                removeContextItems={removeContextItems}
                refresh={refresh}
                setRefresh={setRefresh}
                useSessionStorage={false}
                replaceFunctions={replaceFunctions}
            />
        </div>
    )
}

AccountConfig.propTypes = {
    roles: PropTypes.array,
    onCreateTab: PropTypes.func,
    toastMessages: PropTypes.func
}
